/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as core from '../../core';
import * as errors from '../../errors/index';
import * as Truvity from '../index';

export class UnauthorizedError extends errors.TruvityError {
    constructor(body: Truvity.UnauthorizedProblems, rawResponse?: core.RawResponse) {
        super({
            message: 'UnauthorizedError',
            statusCode: 401,
            body: body,
            rawResponse: rawResponse,
        });
        Object.setPrototypeOf(this, UnauthorizedError.prototype);
    }
}
